export default __webpack_public_path__ + "static/media/logo-guy.603d35f1.svg";